import React, { FC } from 'react';
import { STabButtons } from './styles';

const TabButtonsGroup: FC<{ children?: React.ReactNode }> = ({ children }) => <STabButtons>{children}</STabButtons>;

export default TabButtonsGroup;
